// prism/frontend/src/api/auth.js
// Authentication functions

import { API_BASE, getAuthHeaders, clearAllCaches } from './client.js';

// Check if user is authenticated
export function isAuthenticated() {
  return !!localStorage.getItem("prism_token");
}

// Get current username
export function getCurrentUsername() {
  return localStorage.getItem("prism_username") || "unknown";
}

// Logout
export function logout() {
  localStorage.removeItem("prism_token");
  localStorage.removeItem("prism_username");
  // Clear all caches on logout
  clearAllCaches();
}

// Login
export async function login(username, password) {
  try {
    const res = await fetch(`${API_BASE}/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    });
    if (!res.ok) {
      const error = await res.json();
      throw new Error(error.detail || "Login failed");
    }
    return res.json();
  } catch (error) {
    console.error(error);
    throw error;
  }
}
